import React from 'react';
import useAuthStore from '../stores/authStore';
import DemandForecastChart from '../components/DemandForecastChart';
import DemandDriverAnalysis from '../components/DemandDriverAnalysis';
import CompetitorRateMatrix from '../components/CompetitorRateMatrix';
import SimpleCompetitorMatrix from '../components/SimpleCompetitorMatrix';
import RoomTypePriceTable from '../components/RoomTypePriceTable';
import DashboardStats from '../components/DashboardStats';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Users } from 'lucide-react';

const Dashboard = () => {
  const { user } = useAuthStore();

  return (
    <div className="space-y-6">
      {/* Welcome Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">
            Welcome back, {user?.name || 'User'}!
          </h1>
          <p className="text-muted-foreground">
            Here's your hotel demand and pricing overview
          </p>
        </div>
        
      </div>

      {/* Quick Stats - Hidden per user request */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <DashboardStats />
        
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Occupancy</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">78%</div>
            <p className="text-xs text-muted-foreground">
              +1.8% from last week
            </p>
          </CardContent>
        </Card>
      </div> */}

      {/* Charts Section */}
      <div className="space-y-6">
        {/* 90-Day Demand Forecast */}
        <DemandForecastChart />

        {/* 90-Day Demand Driver Analysis */}
        <DemandDriverAnalysis />

        {/* Simple Competitor Rate Matrix */}
        <SimpleCompetitorMatrix />
        
        {/* Original Competitor Rate Matrix (Hidden for debugging) */}
        {/* <CompetitorRateMatrix /> */}

        {/* Room Type Price Table - Below Competitor Matrix */}
        <RoomTypePriceTable />
      </div>
    </div>
  );
};

export default Dashboard;
